
export default function TableCell({key,className,children }) {
      return (
        <td key={key} className={`border px-4 py-2${className ? " " + className : ""}`}>{children}</td>
      );
  }
